export const FOOTER_DETAILS = {
  ammendedBy: 'Chapter 293',
  ammendedSession: '2022 General Session',
};

export const HEADER_DETAILS = {
  chapterCode: '2',
  chapter: 'Property Tax Act',
  effective: '5/4/2022',
  part: 'County Assessment',
  partCode: '3',
  section: 'Statements by taxpayers -- Power of assessors respecting statements.',
  sectionCode: '306',
  superseded: '1/1/2023',
  titleCode: '59',
  title: 'Revenue and Taxation',
};
